<template>
<div>
  <div class="dorm-types property" v-if="dataServices.properties.length >0">
    <div class="property__title" >
      {{ dataServices.title }}
    </div>
    <ul>
      <li v-for="type in dataServices.properties.slice(0, 9)" :key="type.id">
         <span class="subpage-accordion__icon myfont">
            <svg-icon :type="`icon-${type.slug}`"/>
          </span>
        {{ type.title }}
      </li>
    </ul>

    <slide-up-down :duration="600" :active="showProp" v-if="dataServices.properties.length > 9">
      <ul>
        <li v-for="type in dataServices.properties.slice(9, dataServices.properties.length)" :key="type.id"
            :class="[ type.state ? 'enable' : 'disable' ]">
           <span class="subpage-accordion__icon">
                <svg-icon :type="type.icon"/>
         </span>
          {{ type.title }}
        </li>
      </ul>
    </slide-up-down>

    <div class="more-property" v-if="dataServices.properties.length > 9">
      <v-button
        class="white round footer__button-small btn"
        icon="icon-arrow-down-2"
        icon-position="left"
        @click.native="showTypes()"
        :title="dataServices.properties.length - 9 + ' Özellik Daha'"
      />
    </div>
  </div>
</div>

</template>

<script>
export default {
  name: 'DormProperty',
  props: {
    dataServices: Object
  },
  data () {
    return {
      showProp: false
    }
  },
  methods: {
    showTypes () {
      this.showProp = !this.showProp
    }
  }
}
</script>

<style scoped>
.myfont {
  font-size:36px
}

.myfontTitle {
  font-size:24px
}
</style>
